<template>
  <v-card class="page--reset" flat>

    <v-card-title class="headline">Reset App Data</v-card-title>

    <v-alert
      :value="true"
      color="error"
      icon="warning"
    >
      <p><strong class="title" text-color="error">The buttons below should be used with extreme caution!</strong></p>
      <p>They will result in the permanent deletion of cached room data and unsynced reports, respectively.</p>
    </v-alert>

    <v-card-text>
      <v-layout row class="text-xs-center">
        <v-btn
          @click="$roomService.reset()"
          color="error"
          class="btn__reset_rooms"
          :disabled="resetRoomsDisabled"
        >
          <v-icon left>delete_forever</v-icon>
          <span class="btn__text">Reset Rooms Cache</span>
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          @click="$syncService.reset()"
          color="error"
          class="btn__reset_reports"
          :disabled="resetSyncDisabled"
        >
          <v-icon left>delete_forever</v-icon>
          <span class="btn__text">Delete Unsynced Reports</span>
        </v-btn>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<style>
li.px-0 > .list__tile {
  padding: 0;
}
</style>

<script>
import Vue from 'vue';

export default {
  name: 'sync',
  data() {
    return {};
  },
  computed: {
    resetRoomsDisabled () {
      return !Object.entries(Vue.roomsStore.state.RoomsCache.rooms).map(it => it[1].length).reduce((a, b) => a + b, 0);
    },
    resetSyncDisabled () {
      return !this.$syncService.items.length;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reset.vue